module.exports = __webpack_public_path__ + "img/2.f3805e35.png";